module.exports = __webpack_public_path__ + "img/chevron-down-white.984194f1.svg";